/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {SaveSpace, Space, SpaceSelections} from 'pages/Home/DigitalCast/models/spaces';

interface Options extends SaveSpace {
  data: Space;
}

const restoreSelectedCharts = ({data, saveSpaceSettings}: Options): Space => {
  const newSelections: SpaceSelections = {...data.chartSelected};

  const previous: ChartIds[] = [...newSelections.previous];
  newSelections.previous = [...newSelections.current];
  newSelections.current = previous;

  const result: Space = {
    ...data,
    chartSelected: newSelections,
  };

  saveSpaceSettings(result);

  return result;
};

export default restoreSelectedCharts;
